import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import "../styles.css";
import {
  Link,
  useActionData,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Buttons from "react-multi-date-picker/components/button";

// The dropdown menu for services. It is located in the navbar.
const ListMenu = ({
  componentRef,
  title,
  navListData,
  switchScreen,
  toggleService,
  setSelectedCareService,
}) => {
  // This useEffect automatically populates the services dropdown with every service in the database.
  // If more get added make sure the css keeps the format. If not check everything under the "servicedDropdownContainer" in styles.css.
  const navigate = useNavigate();
  const imgList = {
    Bathing: 13,
    Laundry: 12,
    "Groccery Shopping": 11,
    Transferring: 10,
    Eating: 9,
    "Personal Errands": 8,
    Showers: 7,
    Dressing: 6,
    "Hygiene/Grooming": 5,
    "Meal Preparation": 4,
    "Declutter/Organization": 3,
    Ambulating: 2,
    "Medication Management": 1,
    "Transport to/from appointments": 10,
  };

  const renderNavListDropdown = () => {
    switch (title) {
      case "Service":
        return (
          <>
            <div>
              <div className="dropdown-title">
                <p>Select a service you are interested in</p>
              </div>
              <div className="dropdown-container">
                {navListData.map((service, index) => {
                  const subList = service.sub_services;

                  return (
                    <div className="dropdownItem" key={index}>
                      <div
                        key={index}
                        className={`dropdownItem_bot_color_${index}`}
                      >
                        <a
                          onClick={() => {
                            setSelectedCareService(service);
                            navigate(`/CareServiceProfile`, {
                              state: {
                                data: service,
                                imgIndex: 1,
                              },
                            });

                            toggleService();
                          }}
                          className="navbuttonsServices decorationNone"
                        >
                          {service.care_service_name}
                        </a>
                      </div>
                      {subList.map((subService, subIndex) => {
                        return (
                          <div className="subServiceContainer">
                            <p>{subService.name}</p>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
                <div className="dropdownItem">
                  <div className={`dropdownItem_bot_color_1`}>
                    <a className="navbuttonsServices decorationNone">
                      Coming Soon
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case "My Profile":
        return (
          <>
            {navListData.map((profile, index) => (
              <li
                key={index}
                className="dropdownItem"
                onClick={() => {
                  toggleService();
                  switchScreen(profile.screen);
                  navigate("/UserHome");
                }}
              >
                <a className="navbuttons decorationNone">{profile.name}</a>
              </li>
            ))}
          </>
        );
      default:
        return <></>;
    }
  };
  return (
    <div ref={componentRef} className="servicesDropdownContainer">
      {renderNavListDropdown()}
    </div>
  );
};

export default ListMenu;
